import { useEffect, useState } from "react";

import "./tabs.scss";

export default function Tabs({
  tabs,
  selectedTabDefault,
  onChange,
  classNameBody,
  btnStyle,
}) {
  const [selectedTab, setSelectedTab] = useState(
    selectedTabDefault || tabs[0].id,
  );

  useEffect(() => {
    if (selectedTabDefault) {
      setSelectedTab(selectedTabDefault);
    } else if (!tabs.some((tab) => tab.id === selectedTab)) {
      // Only fall back to the first tab when the current selection no longer
      // exists. Resetting on every `tabs` reference change would snap back to
      // the first tab whenever the parent re-renders (e.g. typing in a field).
      setSelectedTab(tabs[0].id);
    }
  }, [selectedTabDefault, tabs, selectedTab]);

  function changeTab(tab) {
    const newTab = tab.id;
    if (onChange) {
      onChange(newTab);
    } else if (!selectedTabDefault) {
      setSelectedTab(newTab);
    }
  }

  const activeTab = tabs[tabs.findIndex((tab) => tab.id === selectedTab)];

  return (
    <>
      {btnStyle ? (
        <div className="tab-selector">
          {tabs.map(
            (tab) =>
              tab.show !== false && (
                <button
                  key={tab.id}
                  type="button"
                  className={selectedTab === tab.id ? "blue" : ""}
                  onClick={() => changeTab(tab)}
                >
                  {tab.name}
                </button>
              ),
          )}
        </div>
      ) : (
        <div className="tab-bar">
          {tabs.map(
            (tab) =>
              tab.show !== false && (
                <div
                  key={tab.id}
                  className={`tab${selectedTab === tab.id ? " active" : ""}`}
                  onClick={() => changeTab(tab)}
                >
                  {tab.name}
                </div>
              ),
          )}
        </div>
      )}
      <div
        className={`${btnStyle ? "tab-selector-body" : "tab-body"} ${activeTab?.className || ""}${classNameBody ? ` ${classNameBody}` : ""}`}
      >
        {activeTab?.component}
      </div>
    </>
  );
}
